import { useHome } from '../../context/HomeContext';
import { useEffect } from 'react';
import 'swiper/swiper.css';
import './Home.css';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide.min.css';
import { NavigateFn } from '../../utils/interfaces/types';

export interface IHome {
  navigate: NavigateFn;
}

export function Home(props: IHome) {
  const { images, isLoading, error, loadImages } = useHome();

  useEffect(() => {
    loadImages();
  }, [loadImages]);

  return (
    <div className="home">
      <section className="home__hero">
        <p className="home__headline">
          I’m Ot. I’m a graphic designer based in Barcelona. Keen on visual
          perception, culture and language; I’m interested in the meaning behind
          each visual decision, both perceptual and functional. I see design as
          a meeting point between sensibility and research.
        </p>
      </section>

      {error ? (
        // Mostramos mensaje de error
        <div className="home--error"></div>
      ) : // Miramos si se han cargado las imágenes
      isLoading ? (
        // Mostramos un spinner
        <div className="home--loading">
          <div className="loader"></div>
        </div>
      ) : (
        // Mostramos las imágenes
        <div
          className="home__carrousel"
          onClick={() => props.navigate('projects')}
        >
          <Splide
            options={{
              type: 'loop', // Obligatorio para que sea infinito
              snap: true,
              drag: 'free', // Permite al usuario arrastrar libremente
              focus: 'center',
              perPage: 1, // Cuántos elementos se ven a la vez
              arrows: false, // Oculta las flechas si quieres un look limpio
              pagination: false, // Oculta los puntos de abajo
              autoplay: true,
              interval: 8000,
              speed: 3000,
            }}
          >
            {images
              .filter((image) => image.id !== 0)
              .map((image) => (
                <SplideSlide>
                  <img width="80%" src={image.thumbnailImage} alt={image.alt} />
                </SplideSlide>
              ))}
          </Splide>
        </div>
      )}

      {/* ── About block ── */}
      <section className="home__about">
        <div className="home__about-text">
          <p>
            I hold a bachelor's degree in Design from the Universitat de
            Barcelona. I also spent an exchange semester at The Cooper Union for
            the Advancement of Science and Art, which broadened my perspective
            and deepened my knowledge, particularly in typography and user
            experience.
          </p>
          <p>
            I’ve a strong interest in visual culture and communication and I’m
            especially drawn to typography and visual systems. My curiosity also
            extends beyond graphic design into art, cinema, and
            animation—disciplines that I believe share the same purpose:
            expressing ideas, narratives, and emotions through images. I’m
            interested in how this builds meaning and creates cultural
            significance through existence and perception.
          </p>
          <p>
            I’ve developed a significant portion of my professional practice in
            the film industry, working on graphics both diegetic (on-screen
            props and set dressing) and extradiegetic (titles and promotional
            posters). This path has also led me to projects related to culture,
            focused on people and community; projects that carry a deeper
            meaning and intention. I especially enjoy working on local projects,
            small initiatives, and work that feels purposeful.
          </p>
        </div>
        <img
          src={images.find((img) => img.id === 0)?.thumbnailImage}
          alt={images.find((img) => img.id === 0)?.alt}
        />
      </section>
    </div>
  );
}
